<template>
  <v-autocomplete
    :loading="isLoading"
    :items="completeItems"
    :search-input.sync="search"
    flat
    :label="label"
    clearable
    item-text="location"
    item-value="id"
    no-filter
    v-model="model"
    :disabled="disabled"
    :rules="rules"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.location"></v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Search for a
          <strong>Location</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: {
    label:{
      type: String,
      default: "Location"
    },
    value: {
      type: [Number, String],
    },
    warehouseId: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    rules: {
      type: Array,
      default: () => []
    },
    preferedItems:{
      type: Array,
      default: () => []
    }
  },
  computed:{
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit("input", value);
        this.$emit("locationSelected", this.items.find(i => i.id == value))
      }
    },
    completeItems(){
      const items = []
      if(this.preferedItems.length){
        items.push({header:"Prefered Locations"})
        items.push(...this.preferedItems)
        items.push({ divider: true })
        items.push({header:"Other Locations"})
        items.push(...this.items)
      }else{
        items.push(...this.items)
      }
      return items
    }
  },
  watch: {
    search: {
      handler: _.debounce(function() {
        this.getLocations();
      }, 100)
    },
  },
  mounted: function() {
    this.getLocations();
  },
  methods: {
    getLocations() {
      this.isLoading = true;
      this.$store
        .dispatch("warehouseLocation/list", {
          search: this.search,
          warehouseId:this.warehouseId
        })
        .then(({locations}) => {
          this.items = locations.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
